import { create } from 'zustand';
import { authService } from '../services/api';

export const useAuthStore = create((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
  verificacionPendiente: false,

  setUser: (user) => set({ user, isAuthenticated: !!user }),

  login: async (usuario, contrasena, totp_code) => {
    set({ isLoading: true, error: null, verificacionPendiente: false });
    try {
      const response = await authService.login(usuario, contrasena, totp_code);
      const data = response.data;

      if (data?.totp_requerido) {
        set({ isLoading: false });
        return 'totp_requerido';
      }

      const userData = data?.usuario;
      set({ user: userData, isAuthenticated: true, isLoading: false });
      return true;
    } catch (error) {
      const errorMessage =
        error.response?.data?.data?.error ||
        error.response?.data?.error ||
        error.response?.data?.message ||
        'Error al iniciar sesión';
      set({
        error: errorMessage,
        isLoading: false,
        verificacionPendiente: !!(error.response?.data?.verificacion_pendiente),
      });
      return false;
    }
  },

  logout: async () => {
    try {
      await authService.logout();
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }

    // En un equipo compartido no debe quedar nada del usuario en la caché del navegador
    try {
      navigator.serviceWorker?.controller?.postMessage('limpiar-cache');
    } catch { /* sin service worker */ }

    set({
      user: null,
      isAuthenticated: false,
      error: null,
    });
  },

  getMe: async () => {
    set({ isLoading: true });
    try {
      const response = await authService.getMe();
      if (response.status === 200) {
        set({ user: response.data, isAuthenticated: true, isLoading: false });
        return true;
      }
      set({ isAuthenticated: false, user: null, isLoading: false });
      return false;
    } catch {
      set({ isAuthenticated: false, user: null, isLoading: false });
      return false;
    }
  },

  clearError: () => set({ error: null }),
}));

export const useThemeStore = create((set) => ({
  isDarkMode: localStorage.getItem('theme') === 'dark',

  toggleTheme: () => {
    set((state) => {
      const newDarkMode = !state.isDarkMode;
      localStorage.setItem('theme', newDarkMode ? 'dark' : 'light');

      if (newDarkMode) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }

      return { isDarkMode: newDarkMode };
    });
  },

  initTheme: () => {
    const isDark = localStorage.getItem('theme') === 'dark' ||
                   (!localStorage.getItem('theme') && window.matchMedia('(prefers-color-scheme: dark)').matches);

    if (isDark) {
      document.documentElement.classList.add('dark');
    }

    set({ isDarkMode: isDark });
  },
}));

export const usePrivacidadStore = create((set) => ({
  modoPrivado: localStorage.getItem('privacidad') === '1',

  togglePrivacidad: () => {
    set((state) => {
      const nuevo = !state.modoPrivado;
      localStorage.setItem('privacidad', nuevo ? '1' : '0');
      return { modoPrivado: nuevo };
    });
  },
}));
